import { useState } from 'react';
import {
  Box,
  Typography,
  Checkbox,
  IconButton,
  Collapse,
  Stack,
  Chip,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

export function PublicProjectFilter({
  title,
  items = [],
  selectedFilters,
  onFilterChange,
}) {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box
      sx={{
        borderBottom: '1px solid',
        borderColor: 'divider',
        pb: 2,
        mb: 2,
      }}
    >
      {/* HEADER */}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        onClick={() => setExpanded(!expanded)}
        sx={{
          cursor: 'pointer',
          userSelect: 'none',
        }}
      >
        <Typography fontSize={14} fontWeight={300}>
          {title}
        </Typography>

        <IconButton size="small"   aria-label={expanded ? "Collapse section" : "Expand section"}>
          {expanded ? (
            <ExpandLessIcon fontSize="small" />
          ) : (
            <ExpandMoreIcon fontSize="small" />
          )}
        </IconButton>
      </Box>

      {/* DROPDOWN */}
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <Stack spacing={1} mt={1}>
          {items.map((item) => (
            <Box
              key={item.label}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              sx={{
                px: 1,
                borderRadius: 1,
                '&:hover': {
                  bgcolor: 'action.hover',
                },
                  cursor: 'pointer', // make entire row clickable
                }}
              onClick={() =>
                onFilterChange(
                  item.label,
                  !selectedFilters.includes(item.label) // toggle filter
                )
              }
            >
              <Box display="flex" alignItems="center" gap={1}>
                <Checkbox
                sx={{
                    color: '#047857', // unchecked color
                    '&.Mui-checked': {
                      color: '#047857', // checked color
                      },
                    }}                  
                  size="small"
                  checked={selectedFilters.includes(item.label)}
                />
                <Typography fontSize={13}>{item.label}</Typography>
              </Box>

              <Chip
                label={item.count}
                size="small"
                sx={{
                  fontSize: 11,
                  height: 20,
                }}
              />
            </Box>
          ))}
        </Stack>
      </Collapse>
    </Box>
  );
}
